//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { getFlotillasPageInformation } from '~/utils/server'
import FaqItems from '~/components/Flotillas/FaqItems'
import vRating from '~/components/v/rating.vue'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import flotilla from '~/mixins/page/flotilla'
import { getFlag } from '~/utils/languages'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import RequestBoatModal from '~/components/modal/boat/request-boat-modal'
import RequestOfferForm from '~/components/form/user/request-offer-form'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'

export default {
  name: 'FlotillasPage',
  components: {
    FaqItems,
    vRating,
    RequestBoatModal,
    RequestOfferForm
  },
  filters: {
    resizeImageUrl (url, width, height) {
      let result = `${url}`
      if (result.match(/&w=\d*/)) {
        result = result.replace(/&w=\d*/, `&w=${width}`)
      } else if (width) {
        result += `&w=${width}`
      }
      if (result.match(/&h=\d*/)) {
        result = result.replace(/&h=\d*/, `&h=${height}`)
      } else if (height) {
        result += `&h=${height}`
      }
      result = result.replace(/&rect=(\d+(,\d+)*)/, '')
      return result
    }
  },
  mixins: [pageMeta, flotilla],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('flotilla-sailing'),
        url: ctx.route.fullPath
      }])
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
      let lang = ctx.store.getters['lang/locale']
      let ietf = ietfLocale || 'en-gb'

      if (lang === 'us') {
        lang = 'en'
        ietf = 'en-gb'
      }

      await mxGetMeta(ctx, {
        meta: {
          idx: ctx.route.params.country || 'empty',
          method: 'dynamic',
          type: ctx.route.params.location ? 'flotilla_country' : 'flotilla_overview',
          path: ctx.route.path
        }
      })
      const pageInformation = await getFlotillasPageInformation(ctx, { lang, ietf })
      if (Object.keys(pageInformation).length === 0) {
        ctx.redirect(301, ctx.app.router.resolve({ name: 'flotillas', params: {lang: 'en'} }).href)
        return
      }

      return { pageInformation }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  computed: {
    ...mapState({
      pageSeoData: state => state.pageData,
      lang: state => state.lang.locale
    }),
    getSliderSettings: app => (name) => {
      const SETTINGS = {
        reviews: {
          slidesToShow: 1,
          arrows: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                dots: false,
                arrows: true
              }
            }
          ]
        }
      }
      return {
        ...SETTINGS[name]
      }
    }
  },
  data () {
    return {
      page: {
        sticky: false
      },
      ro: null,
      contentHeight: 0,
      showAll: false
    }
  },
  methods: {
    onResize () {
      this.contentHeight = this.$refs.infoBox.offsetHeight
    },
    getFlag (name) {
      return getFlag(name)
    },
    setSticky (isVisible, entry) {
      this.page.sticky = !isVisible
    },
    scrollToElement ($element) {
      const offset = 100
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = document.getElementById($element).getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    this.ro = new ResizeObserver(this.onResize)
    this.ro.observe(this.$refs.infoBox)
  },
  beforeDestroy () {
    this.ro.unobserve(this.$refs.infoBox)
    this.$store.dispatch('removeMetaHead', { type: 'meta', idxParam: 'name', idx: 'twitter:image' })
    this.$store.dispatch('removeMetaHead', { type: 'meta', idxParam: 'property', idx: 'og:image' })
  }
}
